import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

// Import constants
import { CHARS } from '../../constants/schedule';

/**
 * Ensures there is a roomId in the route. If absent, generates one and redirects.
 * Returns the current roomId (maybe undefined on the very first render before redirect effect runs).
 */
export function useRoomBootstrap() {
  const navigate = useNavigate();
  const params = useParams();
  const roomId = params.roomId as string | undefined;

  useEffect(() => {
    if (!roomId) {
      const chars = CHARS;
      let id = '';
      for (let i = 0; i < 8; i++)
        id += chars[Math.floor(Math.random() * chars.length)];
      navigate(`/s/${id}`, { replace: true });
    }
  }, [roomId, navigate]);

  return { roomId };
}

export default useRoomBootstrap;
